import { string, struct } from 'io-ts/Decoder';

export const Request = struct({
	/** The aggregated BoM row, as projected in `ListItem.id`. */
	rowKey: string,

	/** The package to show. Empty clears the override. */
	packageName: string,
});
